import {
  updateHtzOfferCache,
  useHtzOfferPatchMutation,
  useHtzOfferResetReferenceNumberMutation,
  useHtzOfferShowQuery,
} from "@/services/backend/htz/offers/api/offer-api";
import { isImmutable } from "@/services/backend/documents/lib/document-state";
import { ReferenceNumberField } from "@/services/backend/documents/components/reference-number-field";

/**
 * OfferReferenceNumberField edits the reference number of the offer. It is
 * disabled once the offer is immutable.
 */
export function OfferReferenceNumberField({ offerId }: { offerId: string }) {
  const { data } = useHtzOfferShowQuery({ id: offerId });
  const patchReferenceNumber = useHtzOfferPatchMutation();
  const resetReferenceNumber = useHtzOfferResetReferenceNumberMutation();

  if (!data) {
    return null;
  }

  return (
    <ReferenceNumberField
      data={data}
      updateCache={updateHtzOfferCache}
      patchMutation={patchReferenceNumber}
      resetMutation={resetReferenceNumber}
      disabled={isImmutable(data)}
    />
  );
}
